import React from "react";

import { useSiteConfig } from "./Contexts/SiteConfig";

type SiteImageComponent = React.FC<
  React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
  >
>;

export const SiteLogoImage: SiteImageComponent = props => {
  const { logoImage } = useSiteConfig();
  return <img src={logoImage} alt="Bible Society Logo" {...props} />;
};

export const SiteIconImage: SiteImageComponent = props => {
  const { iconImage } = useSiteConfig();
  return <img src={iconImage} alt="Bible Society Icon" {...props} />;
};
